import SERVICE_URL from "../config/API_DATA";
import HttpPost from "../http/httppost.js";
import Logger from "./logger.js";
import { FILE_NAME, LOG_TYPE } from "../config/API_DATA";

export default class RatePlan {
    static buildRequest(pRatePlan,pHotelId,PHotelRoomId) {
        let returnValue = null;
        try {
            let body = pRatePlan

            if(body)
            {
                body.hotelId=pHotelId;
                body.roomId=PHotelRoomId
                body.currency=body.currency.code
                body.lastMinPriceDropPercentage=(body.lastMinPriceDropSign=='-' && parseFloat(body.lastMinPriceDropPercentage)>0 )?'-'+body.lastMinPriceDropPercentage:body.lastMinPriceDropPercentage
                body.isAdvPurchaseEnabled=( body.advPurchase && parseFloat(body.advPurchase)>0)? true:false,
                body. isLastMinuteEnabled=(body.lastMinPriceDropDays && parseFloat(body.lastMinPriceDropDays)>0) ? true:false
                delete body.lastMinPriceDropSign 
                delete body.isactive
            
             RatePlan. validateRatePlan(body)
            }

         
            returnValue = body;
        } catch (err) {
            let body = Logger.buildRequest(
                FILE_NAME.API_UPDATE_RATE_PLAN,
                "error in building body for update Rate Plan  api",
                err.toString(),
                "buildRequest",
                LOG_TYPE.ERROR
            );
            Logger.getResponse(body);
        }
        return returnValue;
    }


static    validateRatePlan(pRatePlanObj) {
        try {
        
          if(pRatePlanObj.isLastMinuteEnabled)
          {
              pRatePlanObj.lastMinPriceDropDays =parseFloat(pRatePlanObj.lastMinPriceDropDays)
              pRatePlanObj.lastMinPriceDropPercentage =parseFloat( pRatePlanObj.lastMinPriceDropPercentage)
          }

          else
          {
            pRatePlanObj.lastMinPriceDropDays =null
            pRatePlanObj.lastMinPriceDropPercentage =null
          }

          if(pRatePlanObj.isAdvPurchaseEnabled)
          {
    pRatePlanObj.advPurchase=parseFloat(pRatePlanObj.advPurchase)
          }
          else
          {
            pRatePlanObj.advPurchase=null;
          }

          pRatePlanObj.extraAdultPrice= pRatePlanObj.extraAdultPrice?pRatePlanObj.extraAdultPrice:0
          pRatePlanObj.extraChildPrice= pRatePlanObj.extraChildPrice?pRatePlanObj.extraChildPrice:0
 
    
        } catch (err) {
                let body = Logger.buildRequest(
                  FILE_NAME.API_UPDATE_RATE_PLAN,
                  "error in validateRatePlan",
                  err.toString(),
                  "validateRatePlan",
                  LOG_TYPE.ERROR
                );
                Logger.getResponse(body);
              }
        
        }

    static async getResponse(pReqOptions) {
        let returnValue = null;
        try {
            returnValue = await HttpPost.makeHttpPostRequest(
                SERVICE_URL.API_UPDATE_RATE_PLAN,
                pReqOptions
            );
        } catch (err) {
            let body = Logger.buildRequest(
                FILE_NAME.API_UPDATE_RATE_PLAN,
                "error in getting Response from update Rate Plan api ",
                err.toString(),
                "getResponse",
                LOG_TYPE.ERROR
            );
            Logger.getResponse(body);
        }
        return returnValue;
    }
}